document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.querySelector(".crew-carousel");
  if (!carousel) return;

  const cards = carousel.querySelectorAll(".crew-card");
  const dots = document.querySelectorAll(".crew-dot");
  const productName = document.querySelector(".product-name");
  const productPrice = document.querySelector(".product-price");
  const productLink = document.querySelector(".product-link");
  const productImg = document.querySelector(".product-img");
  const leftBtn = carousel.querySelector(".crew-left");
  const rightBtn = carousel.querySelector(".crew-right");

  let index = 0,
    animating = false;

  function updateCarousel(newIndex) {
    if (animating) return;
    animating = true;
    index = (newIndex + cards.length) % cards.length;

    cards.forEach((card, i) => {
      const offset = (i - index + cards.length) % cards.length;
      card.className = "crew-card";
      const video = card.querySelector("video");

      if (offset === 0) {
        card.classList.add("center");
        if (video) {
          video.currentTime = 0;
          video.play().catch(() => {});
        }
      } else {
        if (offset === 1) card.classList.add("right-1");
        else if (offset === 2) card.classList.add("right-2");
        else if (offset === cards.length - 1) card.classList.add("left-1");
        else if (offset === cards.length - 2) card.classList.add("left-2");
        else card.classList.add("hidden");
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      }
    });

    dots.forEach((dot, i) => dot.classList.toggle("active", i === index));

    setTimeout(() => {
      const current = cards[index];
      productName.textContent = current.dataset.title || "";
      productPrice.textContent = current.dataset.price || "";
      productLink.href = current.dataset.url || "#";
      productImg.src = current.dataset.img || "";
    }, 300);

    setTimeout(() => (animating = false), 600);
  }

  leftBtn.addEventListener("click", () => updateCarousel(index - 1));
  rightBtn.addEventListener("click", () => updateCarousel(index + 1));
  dots.forEach((dot, i) =>
    dot.addEventListener("click", () => updateCarousel(i))
  );

  cards.forEach((card, i) =>
    card.addEventListener("click", (e) => {
      if (e.target.closest("video")) return; // handled by modal
      updateCarousel(i);
    })
  );

  // Swipe on track (better touch support)
  let startX = 0;
  const track = carousel.querySelector(".crew-track");
  track.addEventListener("touchstart", (e) => (startX = e.touches[0].clientX), {
    passive: true,
  });
  track.addEventListener("touchend", (e) => {
    const diffX = e.changedTouches[0].clientX - startX;
    if (Math.abs(diffX) > 50) updateCarousel(index + (diffX < 0 ? 1 : -1));
  });

  updateCarousel(0);

  // ===== Modal =====
  const modal = document.getElementById("crew-modal");
  const modalVideo = modal.querySelector(".crew-modal-video");
  const modalImg = modal.querySelector(".crew-modal-image");
  const modalTitle = modal.querySelector(".crew-modal-title");
  const modalPrice = modal.querySelector(".crew-modal-price");
  const modalBuy = modal.querySelector(".crew-modal-buy");
  const modalClose = modal.querySelector(".crew-modal-close");
  const modalPrev = modal.querySelector(".crew-modal-prev");
  const modalNext = modal.querySelector(".crew-modal-next");
  const modalProductImg = modal.querySelector(".crew-modal-product-img");

  let modalIndex = 0;

  function openModal(i) {
    modalIndex = i;
    const card = cards[modalIndex];
    const videoSrc = card.querySelector("video source")?.src;

    if (videoSrc) {
      modalImg.style.display = "none";
      modalVideo.style.display = "block";
      modalVideo.src = videoSrc;
      modalVideo.load();
      modalVideo.play().catch(() => {});
    } else {
      modalVideo.pause();
      modalVideo.removeAttribute("src");
      modalVideo.load();
      modalVideo.style.display = "none";
      modalImg.style.display = "block";
      modalImg.src = card.dataset.img || "";
    }

    modalTitle.textContent = card.dataset.title;
    modalPrice.textContent = card.dataset.price;
    modalBuy.href = card.dataset.url;
    modalProductImg.src = card.dataset.img || "";

    modal.classList.add("active");
    modal.setAttribute("aria-hidden", "false");
  }

  function closeModal() {
    modal.classList.remove("active");
    modal.setAttribute("aria-hidden", "true");
    modalVideo.pause();
    modalVideo.removeAttribute("src");
    modalVideo.load();
  }

  function nextModal() {
    modalIndex = (modalIndex + 1) % cards.length;
    openModal(modalIndex);
    updateCarousel(modalIndex);
  }

  function prevModal() {
    modalIndex = (modalIndex - 1 + cards.length) % cards.length;
    openModal(modalIndex);
    updateCarousel(modalIndex);
  }

  carousel.querySelectorAll(".media-video").forEach((vidEl, i) => {
    vidEl.addEventListener("click", (e) => {
      e.stopPropagation();
      openModal(i);
      updateCarousel(i);
    });
  });

  modalClose.addEventListener("click", closeModal);
  modalNext.addEventListener("click", nextModal);
  modalPrev.addEventListener("click", prevModal);

  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });
});
